import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  const handleTryAgain = () => {
    navigate('/settings?tab=account');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <XCircle className="w-8 h-8 text-gray-600" />
          </div>
          <CardTitle className="text-xl text-gray-700">Payment Cancelled</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          <div className="space-y-2">
            <p className="text-slate-600">
              Your payment was cancelled. No charges were made to your account.
            </p>
            <p className="text-sm text-slate-500">
              You can try upgrading again anytime from your account settings.
            </p>
          </div>

          <div className="bg-slate-50 p-4 rounded-lg text-sm">
            <div className="font-medium text-slate-700 mb-2">Why upgrade to Pro?</div>
            <ul className="text-left space-y-1 text-slate-600">
              <li>✨ Unlimited projects</li>
              <li>🤖 Unlimited AI improvements</li>
              <li>⚡ Priority support</li>
              <li>🚀 Early access to new features</li>
            </ul>
          </div>

          <div className="space-y-3">
            <Button 
              className="w-full bg-gradient-to-r from-violet-600 to-purple-600 hover:from-violet-700 hover:to-purple-700"
              onClick={handleTryAgain}
            >
              <CreditCard className="w-4 h-4 mr-2" />
              Try Upgrading Again
            </Button>
            
            <Button 
              variant="outline" 
              className="w-full"
              onClick={handleBackToDashboard}
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Dashboard
            </Button>
          </div>

          <div className="text-center text-xs text-slate-500">
            <p>Questions? Contact our support team anytime.</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SubscriptionCancel;